import { ITransportActiveDocumentLine } from 'interfaces';
import { BaseService } from './BaseService';
import { axiosPrivate } from 'services/axios';
import toast from 'features/toast';

class TransportDocumentActiveLineService extends BaseService<ITransportActiveDocumentLine> {
  constructor() {
    super('transport-active-document-lines');
  }
  async getAllBaseInformation(params: Record<string, unknown> = {}) {
    try {
      const res = await axiosPrivate.get(`${this.modulePrefix}/`, { params });
      return res.data.results;
    } catch (e) {
      toast.error(e.message);
    }
  }

  bulkCreate = async (ddt_id: number, lines: ITransportActiveDocumentLine[]) => {
    const res = await axiosPrivate.post(`${this.modulePrefix}/bulk-create/`, {
      lines,
      ddt_id
    });
    return res;
  };

  getAlreadySelectedProducts = async (params: Record<string, unknown> = {}) => {
    const res = await axiosPrivate.get(`${this.modulePrefix}/already-selected-products/`, {
      params: params
    });
    return res.data;
  };
}

export const transportDocumentActiveLineService = new TransportDocumentActiveLineService();
